// Formatting helpers for the Arb/EV cards on AdvantageBetting.tsx.

// The sportsbook field name on an arb leg varies across API versions, so fall
// back through the known spellings and finally the odds id.
export interface LegBookFields {
  odds_id: string;
  sportsbook?: string;
  book_name?: string;
  [key: string]: unknown;
}

export function legBook(leg: LegBookFields): string {
  return (
    leg.sportsbook ??
    leg.book_name ??
    (leg["book"] as string | undefined) ??
    leg.odds_id
  );
}

export function fmtOdds(price: number | undefined): string {
  if (price == null) return "—";
  return price > 0 ? `+${price}` : String(price);
}

export function fmtPct(v: number, decimals = 1): string {
  return `${(v * 100).toFixed(decimals)}%`;
}

export function humanizeMarket(s: string): string {
  return s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function tierColor(tier: string): string {
  switch (tier) {
    case "A":
      return "#4ade80";
    case "B":
      return "#a3e635";
    case "C":
      return "#f59e0b";
    default:
      return "#ef4444";
  }
}
